<div>
    <ng-container *ngIf="isLoading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-container>
    <button mat-icon-button type="button" matDialogClose tabindex="-1" class="btn-close"><mat-icon>close</mat-icon></button>
    <br>
    <br>
    <div class="center">
        <form [formGroup]="resetForm">
            <mat-form-field class="input">
                <input matInput placeholder="Email" id="email" name="email" [(ngModel)]="email" type="email" formControlName="email" required>
                <mat-hint>Enter the account's email address</mat-hint>
                <mat-error>
                    Enter a valid email address
                </mat-error>
            </mat-form-field>
            <p *ngIf="emailSent" class="success">Email has been sent</p>
            <p *ngIf="errorMessage" class="error">{{errorMessage}}</p>
            <div mat-dialog-actions class="buttons">
                <button *ngIf="!isLoading" mat-raised-button color="primary" type="submit" (click)="resetPassword()" class="btn btn-default">Send email</button>
                <button *ngIf="isLoading" mat-raised-button color="primary" type="submit" class="btn btn-default" disabled>Send email</button>
            </div>
        </form>
    </div>
</div>
